import React from 'react';
import PropTypes from 'prop-types';
import getStarRatingStarsState, { STAR_STATE } from '../getStarRatingStarsState';
import Icon from '../../Icon';
import STAR_SVG_TYPE from '../starSvgType';
/**
 * The StarRatingReadOnly component displays a set of star SVGs to visualize static rating value
 *
 * ## Related Components
 * - [StarRatingUpdateable](../StarRatingUpdateable/README.md)
 *
 * ## Composed of
 * - [Icon](../../Icon/README.md)
 *
 * ## Usage
 * ```jsx
 * <StarRating starSize="4" value={4} maxValue={5} />
 * ```
 * ## Props
 */

var StarRatingReadOnly = function StarRatingReadOnly(props) {
  var maxValue = props.maxValue,
      qa = props.qa,
      starSize = props.starSize,
      value = props.value;

  var getStarClassName = function getStarClassName(_ref) {
    var config = _ref.config;
    if (config === STAR_STATE.FULL) return STAR_SVG_TYPE.FULL;
    if (config === STAR_STATE.EMPTY) return STAR_SVG_TYPE.EMPTY;
    return STAR_SVG_TYPE.HALF;
  };

  var ratingConfigs = getStarRatingStarsState(value, maxValue);
  return ratingConfigs.map(function (config, idx) {
    return /*#__PURE__*/React.createElement(Icon, {
      key: "star-value-static-".concat(idx + 1),
      qa: "".concat(qa, "#rating-").concat(idx + 1, "#icon"),
      size: starSize,
      type: getStarClassName({
        config: config
      })
    });
  });
};

StarRatingReadOnly.defaultProps = {
  qa: '',
  maxValue: 5,
  starSize: '5',
  value: 0
};
StarRatingReadOnly.propTypes = {
  /**
   * The max value of rating
   */
  maxValue: PropTypes.number,

  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * The size of star icon to render
   */
  starSize: PropTypes.string,

  /**
   * The rating value
   */
  value: PropTypes.number
};
export default StarRatingReadOnly;